import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { Suitability } from '../../../../models/suitability/suitability';
import { PersonService } from '../../../../services/person.service';
import { SuitabilityScoreBehaviorService } from '../../../../state-manager/behavior-subjects/suitability-behavior.service';

@Component({
  selector: 'app-suitability-thermometer',
  templateUrl: './suitability-thermometer.component.html',
  styleUrls: ['./suitability-thermometer.component.scss']
})
export class SuitabilityThermometerComponent implements OnInit, OnChanges {
  profileName = 'Carregando ...';
  @Input() agentId: string;

  constructor(
    protected suitabilityBehaviorService: SuitabilityScoreBehaviorService,
    protected personService: PersonService
  ) {}

  ngOnInit() {}

  ngOnChanges() {
    if (this.agentId) {
      this.personService
        .getScoreByAgent(this.agentId)
        .subscribe((response) => {
          const { suitability } = response;
          this.profileName = suitability.profile;
          const element = <HTMLImageElement>(document.querySelector('.thermometer-container img'));
          if (element) {
            element.src = `/assets/images/suitability/${this.profileName.toLowerCase()}.svg`;
          }
        });
    }
  }
}
